import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-add-to-solar-flow',
  templateUrl: './add-to-solar-flow.component.html',
  styleUrls: ['./add-to-solar-flow.component.scss']
})
export class AddToSolarFlowComponent implements OnInit {
  @ViewChild('queryDataTable', { static: true })
  public queryDataTable: Table;
  
  public userId: any;
  public appIds: any;
  public password: any;


  constructor(
    private cryptoJsService: CryptoJsService, 
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    private loader: AppLoaderService,
    private apiService: DashboardService,
  ) { }


  ngOnInit(): void {
    const token: any = JSON.parse(sessionStorage.getItem('token'));
    // console.log('token1', token);
    // this.vendorRegId = JSON.stringify(token?.officeCode);
    // console.log('officeCode', this.vendorRegId);
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

  }

  onSubmit() {
    if(this.appIds == null || this.appIds == ""){
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Please Enter Application Ids.',
      });
      return;
    }
    if(this.password == null || this.password == ""){
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Please Enter password.',
      });
      return;
    }
    let reqBody = {
      userId: this.cryptoJsService.Encrypt(this.userId),
      appIds: this.cryptoJsService.Encrypt(this.appIds),
      passCode: this.cryptoJsService.Encrypt(this.password),
    }
    this.postQuery(reqBody);
  }


  postQuery(reqBody){
    this.loader.start();
    this.apiService
      .addToSolarFlow(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.password = null;
          // this.appIds = null;

          if(data[0]?.Column1 == 'Success'){
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: data[0] ? data[0]?.Column1 : '',
            });
          }else{
            this.messageService.add({
              severity: 'info',
              summary: 'info',
              detail: JSON.stringify(data),
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        }
      });
  }


}
